// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/generative_ai/agent/:id/execution_stats" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { generativeAiAgentIdExecutionStats } from "./constants";
import type { GenerativeAiAgentIdExecutionStatsResult } from "./types";
import { isGenerativeAiAgentIdExecutionStatsResult } from "./validators";

export const getGenerativeAiAgentIdExecutionStats = reactQueryFetcherAdapter(
  generativeAiAgentIdExecutionStats,
  (
    signal: AbortSignal,
    id: string,
    startDate: number,
    endDate: number
  ): Promise<GenerativeAiAgentIdExecutionStatsResult> => {
    return fetch(
      `/generative_ai/agent/${id}/execution_stats`,
      "GET",
      { start_date: startDate, end_date: endDate },
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isGenerativeAiAgentIdExecutionStatsResult
);
